import { ProductAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import PlusCircleLine from "@store/Components/Icons/PlusCircle/PlusCircleLine";
import { actionLinkStyles } from "@store/theme/mixins";
import { css } from "styled-components";

export const addToListLinkProps: ProductAddToListLinkStyles = {
    link: {
        icon: {
            iconProps: {
                src: PlusCircleLine,
                size: 24,
                color: "inherit",
                css: css`
                    margin-right: 0.25em;
                `,
            },
            position: "left",
        },
        css: css`
            ${actionLinkStyles()}
        `,
    },
};
